import GoogleIcon from '@mui/icons-material/Google'
import { Alert, Button, CircularProgress, Paper, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Kenneth } from '@/components/ui'
import { CenteredLayout } from '@/layouts'
import { useAuthStore } from '@/stores/authStore'

export const LoginPage = () => {
  const { signInWithGoogle, isAuthenticated, isLoading, error } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/orgs', { replace: true })
    }
  }, [isAuthenticated, navigate])

  return (
    <CenteredLayout>
      <Box variant='flexCenter' mb={-1} zIndex={1}>
        <Kenneth size={120} animation='sparkles' />
      </Box>
      <Paper variant='form'>
        <Box variant='flexColumn'>
          <Typography variant='h5' color='text.primary' textAlign='center'>
            welcome to your
          </Typography>
          <Typography variant='h1' color='text.primary' textAlign='center' fontFamily='"Unica One", sans-serif'>
            Untool Mage
          </Typography>
        </Box>

        {error && <Alert severity='error'>{error}</Alert>}
        <Box variant='flexColumn'>
          <Button
            variant='contained'
            fullWidth
            startIcon={isLoading ? <CircularProgress size={20} color='inherit' /> : <GoogleIcon />}
            onClick={signInWithGoogle}
            disabled={isLoading}
          >
            {isLoading ? 'Signing in...' : 'Sign in with Google'}
          </Button>

          <Typography variant='body2' color='text.primary' textAlign='center'>
            Use your @barti.com Google account to continue
          </Typography>
        </Box>
      </Paper>
    </CenteredLayout>
  )
}
